import React, { useEffect } from 'react';
import { FormHelperText, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useDropzone } from 'react-dropzone';
import { useSelector } from 'react-redux';

import { useDefineUserRole, useFormatMessage } from '../../../../../hooks';
import { useImportNewProducts } from './useProducts';
import AlertDialog from '../../../../../components/ui/Dialog/AlertDialog';
import { IAppState } from '../../../../../store/rootDuck';
import { ButtonWithLoader } from '../../../../../components/other/Buttons';

export function ImportNewProducts() {
  const fm = useFormatMessage();
  const { classes } = useStyles();
  const { me } = useSelector((store: IAppState) => ({
    me: store.profile.me,
  }));
  const isManager = useDefineUserRole(me, ['ROLE_MANAGER']);
  const [isAlertOpen, setAlertOpen] = React.useState(false);
  const { upload, loadingUpload, successUpload, errors } = useImportNewProducts();

  const handleDrop = async (droppedFiles: File[]) => {
    const file = new FormData();
    file.append('file', droppedFiles[0]);
    upload({ file });
  };
  const { open, getInputProps } = useDropzone({ onDrop: handleDrop, noClick: true });

  useEffect(() => {
    successUpload && setAlertOpen(true);
  }, [successUpload]);

  if (!me?.is_admin && !isManager) return null;

  return (
    <>
      <Typography className={classes.title}>{fm('IMPORT.NEW.PRODUCTS')}</Typography>
      <div className={classes.container}>
        <div className={classes.containerBtns}>
          <input {...getInputProps()} />
          <ButtonWithLoader onPress={() => open()} loading={loadingUpload}>
            {fm('UPLOAD.NEW.PRODUCTS')}
          </ButtonWithLoader>
        </div>
        {errors.map(i => (
          <FormHelperText error className={classes.helperText} key={i}>
            {i}
          </FormHelperText>
        ))}

        <AlertDialog
          open={isAlertOpen}
          title={fm('UPLOAD.OFFER.SUCCESS.TITLE')}
          cancelText={fm('CATEGORIES.DELETE.OK')}
          okText=''
          handleClose={() => {
            setAlertOpen(false);
          }}
          handleAgree={() => {
            setAlertOpen(false);
          }}
        />
      </div>
    </>
  );
}

const useStyles = makeStyles()(() => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },
    containerBtns: {
      display: 'flex',
      flexDirection: 'row',
      gap: 20,
    },
    helperText: {
      fontSize: 17,
    },
    title: {
      fontSize: '1.75rem',
      fontWeight: 600,
      marginBottom: 20,
    },
  };
});
